export enum DateFormats {
    FORMAT_1 = "YYYY-MM-DD",
    FORMAT_2 = "YYYY/MM/DD",
  }